var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.desc))]),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.haveButton),expression:"haveButton"}],staticClass:"btn",on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }